import "../App.css";
import Header from "../screens/Header";
import RefundAndReturnPolicyScreen from "../screens/RefundAndReturnPolicyScreen";
import Footer from "../screens/Footer";
import ScrollUpBtn from "../components/ScrollUpBtn";

function RefundAndReturnPolicy() {
  return (
    <div className="App">
      <Header />
      <RefundAndReturnPolicyScreen />
      <Footer />
      <ScrollUpBtn />
    </div>
  );
}

export default RefundAndReturnPolicy;
